import { useEffect, useState } from "react";

const imageContext = require.context(
  "./images/carousel",
  false,
  /\.(avif|gif|jpe?g|png|webp)$/i
);
const images = imageContext.keys().sort().map(imageContext);

export default function ImageCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return undefined;

    const timer = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % images.length);
    }, 4500);

    return () => window.clearInterval(timer);
  }, [isPaused]);

  const goToPrevious = () => {
    setActiveIndex((current) => (current - 1 + images.length) % images.length);
  };

  const goToNext = () => {
    setActiveIndex((current) => (current + 1) % images.length);
  };

  return (
    <div
      className="gallery"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onFocus={() => setIsPaused(true)}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setIsPaused(false);
      }}
      aria-roledescription="carousel"
      aria-label="Lobo Powerlifting team gallery"
    >
      <div className="gallery__frame">
        <img
          key={images[activeIndex]}
          className="gallery__image"
          src={images[activeIndex]}
          alt={`Lobo Powerlifting team at event ${activeIndex + 1}`}
        />
        <div className="gallery__shade" aria-hidden="true" />
        <p className="gallery__index" aria-live="polite">
          <strong>{String(activeIndex + 1).padStart(2, '0')}</strong>
          <span>/ {String(images.length).padStart(2, '0')}</span>
        </p>
        <div className="gallery__controls">
          <button type="button" onClick={goToPrevious} aria-label="Previous team photo">
            <span aria-hidden="true">←</span>
          </button>
          <button type="button" onClick={goToNext} aria-label="Next team photo">
            <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>

      <div className="gallery__rail" aria-label="Choose a team photo">
        {images.map((src, index) => (
          <button
            type="button"
            key={src}
            className={index === activeIndex ? 'is-active' : ''}
            onClick={() => setActiveIndex(index)}
            aria-label={`Show team photo ${index + 1}`}
            aria-current={index === activeIndex ? 'true' : undefined}
          >
            <span>{String(index + 1).padStart(2, '0')}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
